<ion-header>
  <ion-toolbar color="medium">
    <ion-title style="color: white;">Enter your answer for inference</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeModal('close')">
        <ion-icon style="color: white;" name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>


<ion-content class="ion-padding" style="border: rgb(188, 183, 183) 2px solid;">
  <div>
    <ion-label color="medium" style="padding: 10px;"><strong>{{ data.question }}</strong></ion-label>
  </div>

  <ion-card class="custom-card">

    <ion-card-content style="padding: 0px;">
      <ion-item lines="inset">
        <ion-input  [(ngModel)]="answer" placeholder="Enter you answer here..." clearInput required></ion-input>
      </ion-item>

      
    </ion-card-content>
  </ion-card>
  <div style="margin-left: 10px;" class="error-message" [class.hidden]="isAnswerValid">
          Answer is required.
  </div>

  <div class="button-group">
    <ion-button expand="block" color="primary" (click)="saveAnswer()">
      <ion-icon slot="start"></ion-icon>
      Inference
    </ion-button>
   
  </div>

  <div style="text-align:center; margin: 10px 0;">
    <ion-button size="small" color="primary" (click)="toggleStaticList()">
      {{ showStaticList ? 'Hide Available Answers' : 'Show Available Answers' }}
    </ion-button>
  </div>

  <ion-list *ngIf="showStaticList">
    <ion-item *ngFor="let stat of staticStats">
      <ion-label>{{ stat }}</ion-label>
    </ion-item>
  </ion-list>

</ion-content>


